/*eslint-disable */
// import TprepSessionModel from '../../Model/TprepSession'
import request from '../../Utils/curl'
import Utility from "../../Utils/utility";

let TprepQuiz =  {
  /**
   * tprep_quizList
   */
  async tprep_quizList (context, whereFilter=null) {
    try{
      Utility.showLoader = true;
      Utility.loadingMsg = "Please wait....";

      let post_data = new FormData();  
      if (whereFilter) {
        post_data.append('filter', JSON.stringify(whereFilter))
      }

      return await request.curl(context, "app_list_console", post_data)
        .then(async response => {
          return response
        });

    }
    catch(err){
      console.error('Exception occurred at tprep_quizList() and Exception:',err.message)
    }
    finally{
      Utility.showLoader = false;
    }
  },
  /**
   * tprep_quizList_analytics
   * used to calculate the count of apps that are tagged under each testseriees subject_module
   */
  async tprep_quizList_analytics (context, filter = {}) {
    try{
      let post_data = new FormData();
      post_data.append('filter', JSON.stringify(filter));
      return await request.curl(context, "app_list_console_analytics", post_data)
        .then(async response => {
          return response
        });
    }
    catch(err){
      console.error('Exception occurred at tprep_quizList_analytics() and Exception:',err.message)
    }
  }
}

export {
  TprepQuiz
}
